
const initailState = {
    arr:[],
    nextKey:''
}
const MobileData=(state=initailState,action)=>{
    switch(action.type){
        case 'ADD_Mobile_DATA':
            return{ 
                arr: state.arr.concat(action.payload),
                nextKey:action.keynext
            }
        default:
            return state;
    }
}

export default MobileData